// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileFeed-cls1_UJb","cls2":"ProfileFeed-cls2_QTE ProfileFeed-cls1_UJb"};